import * as React from 'react';

import {Attachment, Checklist, ErrorResponse} from '../api/dtos/dtos';
import {LoadingOverlayHandler, withLoadingOverlay} from '../app/ApplicationContext';
import VerticalBaseFormItem from "../common/form-items/VerticalBaseFormItem";
import ImageUploadEditor from "../common/input/ImageUploadEditor";
import {UploadFile} from "antd/lib/upload/interface";
import {mapAttachmentToUploadFile} from "../common/input/image";
import furoApi from "../api/FuroApi";
import {WrappedFormUtils} from "antd/lib/form/Form";

interface ChecklistImageFormItemProps {
  checklist?: Checklist;
  editable: boolean;
  form: WrappedFormUtils;
  fieldId: string;
  required: boolean;
  disabled?: boolean;
  onChange?: () => void;
}

interface ChecklistFormState {
  error?: ErrorResponse;
  files: Array<UploadFile<Attachment>>;
}

class ChecklistImageFormItem extends React.Component<ChecklistImageFormItemProps, ChecklistFormState> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: ChecklistImageFormItemProps) {
    super(props);
    this.state = {
      files: this.mapAttachments(),
    }
  }

  public componentDidMount() {
    if (this.props.editable) {
      this.props.form.validateFields([this.props.fieldId]);
    }
  }


  public render() {
    const {
      checklist,
      editable,
      form,
      fieldId,
      required,
    } = this.props;
    const {files} = this.state;

    const rentalDisabled = checklist?.acceptedAt !== null || !editable;
    const deleteDisabled = checklist?.acceptedAt !== null || (checklist.sendoutAt !== null && files.length <= 5);

    return (
      <VerticalBaseFormItem
        fieldId={fieldId}
        form={form}
        required={required}
        initialValue={files}
        input={
          <ImageUploadEditor<Attachment>
            required={true}
            disabled={rentalDisabled}
            files={files}
            onUpload={this.uploadImage}
            onDelete={this.deleteImage}
            deleteDisabled={deleteDisabled}
          />
        }
      />
    );
  }

  private mapAttachments = ():
    Array<UploadFile<Attachment>> => {
    const {checklist} = this.props;
    return checklist?.attachments.map(mapAttachmentToUploadFile) ?? [];
  }


  private uploadImage = (file: Blob): Promise<Attachment> => {
    const {checklist} = this.props;
    return furoApi.checklist.uploadAttachment(checklist?.id!, file).then((c) => {
      return this.onImageUploaded(c)
    }).catch((e) => {
      this.onApiError(e);
      return Promise.reject(e);
    });

  }

  private onImageUploaded = (c: Attachment): Attachment => {
    const file = mapAttachmentToUploadFile(c);
    this.setState(prevState => ({
      files: [...prevState.files, file],
    }), () => {
      this.validate();
      this.onImageChanged();
    });
    return c;
  }

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  }

  private deleteImage = (file: UploadFile): Promise<void> => {
    if (file.uid === undefined) {
      return Promise.resolve();
    }

    const {checklist} = this.props;
    const promise = furoApi.checklist.deleteAttachment(checklist?.id!, Number(file.uid)).then(() => {
      this.onFileDeleted(file.uid);
    })
    withLoadingOverlay(promise, this.loadingHandler);
    return promise;
  }

  private onFileDeleted = (uid: string) => {
    this.setState(prevState => ({
      files: [...prevState.files.filter(value => value.uid !== uid)],
    }), () => {
      this.validate();
      this.onImageChanged();
    });
  }

  private validate = () => {
    const {form, fieldId} = this.props;
    form.setFieldsValue({
      [fieldId]: this.state.files,
    });
    this.props.form.validateFields([fieldId]);
  }

  private onImageChanged() {
    const {onChange} = this.props;
    if (onChange) {
      onChange();
    }
  }
}

export default ChecklistImageFormItem;




// WEBPACK FOOTER //
// ./src/checklist/ChecklistImageFormItem.tsx